import {createReducer, on} from '@ngrx/store';
import {setClaims} from './claims.actions';

const initialState: object = null;

export const claimsReducer = createReducer(
  initialState,
  on(setClaims, (_, {value}) => value)
);
